import React from 'react';
import style from './empty.module.scss';
import classnames from 'classnames';
export const EmptyList = props => {
    return (React.createElement("div", { className: `${props.className || ''} ${style.emptyContainer}`, style: props.style || {} },
        React.createElement("div", { className: `${props.bodyClassName || ''} ${style.emptyWrap}` },
            React.createElement("div", { className: classnames(style.emptyImg, { [style.emptyImgCustoms]: props.isCustoms }) }),
            props.children)));
};
EmptyList.defaultProps = {
    isCustoms: false,
};
